<template>
  <div>
    <v-row v-if="!isLoading">
      <!-- 1. Total Earnings Card (Navy/Blue Gradient) -->
      <v-col
        cols="12"
        sm="6"
        md="3"
      >
        <v-card class="summary-card gradient-card elevation-0 cursor-pointer hover-card" @click="showCompanyNetProfitModal = true">
          <v-card-text class="pa-5 white--text fill-height d-flex flex-column justify-space-between">
            <div>
              <div class="d-flex align-center justify-space-between">
                <span class="text-caption font-weight-bold text-uppercase tracking-wider opacity-80">صافي أرباح الشركة</span>
                <v-avatar size="36" class="white-opacity-bg">
                  <v-icon color="white" size="20">mdi-currency-usd</v-icon>
                </v-avatar>
              </div>
              <h2 class="text-h5 font-weight-bold mt-4 mb-1 white--text">
                {{ totalAdminEarnings || '0.00 EGP' }}
              </h2>
            </div>
            <div class="text-caption font-weight-medium white--text opacity-90">
              <v-icon size="14" color="gold" class="me-1">mdi-chart-line</v-icon>
              <span class="gold--text font-weight-bold">انقر لعرض التقرير التفصيلي</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- 2. Total Reservations Card -->
      <v-col
        cols="12"
        sm="6"
        md="3"
      >
        <v-card class="summary-card elevation-0 cursor-pointer hover-card" @click="showBookingRevenueModal = true">
          <v-card-text class="pa-5 fill-height d-flex flex-column justify-space-between">
            <div>
              <div class="d-flex align-center justify-space-between">
                <span class="text-caption font-weight-bold text-uppercase tracking-wider grey-text">إيرادات الحجوزات</span>
                <v-avatar size="36" color="rgba(16, 185, 129, 0.12)">
                  <v-icon color="#10B981" size="20">mdi-poll</v-icon>
                </v-avatar>
              </div>
              <h2 class="text-h5 font-weight-bold mt-4 mb-1 dark-blue-text">
                {{ totalReservations.amount || '0' }}
              </h2>
            </div>
            <div class="text-caption font-weight-medium success--text">
              <v-icon size="14" color="success" class="me-1">mdi-cash-register</v-icon>
              <span class="font-weight-bold">انقر لعرض إيرادات الحجوزات</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- 3. Drivers Earnings Card -->
      <v-col
        cols="12"
        sm="6"
        md="3"
      >
        <v-card class="summary-card elevation-0 cursor-pointer hover-card" @click="showDriverEarningsModal = true">
          <v-card-text class="pa-5 fill-height d-flex flex-column justify-space-between">
            <div>
              <div class="d-flex align-center justify-space-between">
                <span class="text-caption font-weight-bold text-uppercase tracking-wider grey-text">أرباح السائقين</span>
                <v-avatar size="36" color="rgba(59, 130, 246, 0.12)">
                  <v-icon color="#3B82F6" size="20">mdi-cash-multiple</v-icon>
                </v-avatar>
              </div>
              <h2 class="text-h5 font-weight-bold mt-4 mb-1 dark-blue-text">
                {{ totalDriversEarnings.amount || '0.00 EGP' }}
              </h2>
            </div>
            <div class="text-caption font-weight-medium info--text">
              <v-icon size="14" color="info" class="me-1">mdi-account-cash</v-icon>
              <span class="font-weight-bold">انقر لعرض أرباح السائقين</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- 4. Total Refunds Card -->
      <v-col
        cols="12"
        sm="6"
        md="3"
      >
        <v-card class="summary-card elevation-0 cursor-pointer hover-card" @click="showRefundsModal = true">
          <v-card-text class="pa-5 fill-height d-flex flex-column justify-space-between">
            <div>
              <div class="d-flex align-center justify-space-between">
                <span class="text-caption font-weight-bold text-uppercase tracking-wider grey-text">المبالغ المستردة</span>
                <v-avatar size="36" color="rgba(239, 68, 68, 0.12)">
                  <v-icon color="#EF4444" size="20">mdi-close-octagon-outline</v-icon>
                </v-avatar>
              </div>
              <h2 class="text-h5 font-weight-bold mt-4 mb-1 dark-blue-text">
                {{ totalRefunds.amount || '0.00 EGP' }}
              </h2>
            </div>
            <div class="text-caption font-weight-medium error--text">
              <v-icon size="14" color="error" class="me-1">mdi-cash-refund</v-icon>
              <span class="font-weight-bold">انقر لعرض المبالغ المستردة</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

    <!-- Statistics Overview Card -->
    <v-col
      cols="12"
      md="12"
    >
      <dashboard-statistics-card :all-counts="allCounts"></dashboard-statistics-card>
    </v-col>

    <!-- Chart: Trips Overview -->
    <v-col
      cols="12"
      sm="12"
      md="6"
    >
      <dashboard-weekly-overview
        :trip-count="plannedTripsCount"
        :trip-dates="plannedTripsDates"
        class="dashboard-chart-card elevation-0"
      ></dashboard-weekly-overview>
    </v-col>

    <!-- Chart: Best Seller Trips -->
    <v-col
      cols="12"
      md="6"
    >
      <dashboard-card-sales-by-trips
        :best-trips="bestTrips"
        class="dashboard-chart-card elevation-0"
      ></dashboard-card-sales-by-trips>
    </v-col>
  </v-row>
  
  <!-- Skeleton Loader Layout -->
  <v-row v-else>
    <v-col v-for="i in 4" :key="i" cols="12" sm="6" md="3">
      <v-skeleton-loader type="card" height="140" class="rounded-lg border-1"></v-skeleton-loader>
    </v-col>
    <v-col cols="12">
      <v-skeleton-loader type="card" height="120" class="rounded-lg border-1"></v-skeleton-loader>
    </v-col>
    <v-col cols="12" sm="6" md="6">
      <v-skeleton-loader type="image" height="400" class="rounded-lg border-1"></v-skeleton-loader>
    </v-col>
    <v-col cols="12" md="6">
      <v-skeleton-loader type="image" height="400" class="rounded-lg border-1"></v-skeleton-loader>
    </v-col>
  </v-row>

  <!-- FINANCIAL DRILL-DOWN REPORT MODALS -->
  <CompanyNetProfitModal v-model="showCompanyNetProfitModal" />
  <BookingRevenueModal v-model="showBookingRevenueModal" />
  <DriverEarningsModal v-model="showDriverEarningsModal" />
  <RefundsModal v-model="showRefundsModal" />
</div>
</template>

<script>
import auth from '@/services/AuthService'
import DashboardStatisticsCard from './DashboardStatisticsCard.vue'
import DashboardCardSalesByTrips from './DashboardCardSalesByTrips.vue'
import DashboardWeeklyOverview from './DashboardWeeklyOverview.vue'
import CompanyNetProfitModal from './CompanyNetProfitModal.vue'
import BookingRevenueModal from './BookingRevenueModal.vue'
import DriverEarningsModal from './DriverEarningsModal.vue'
import RefundsModal from './RefundsModal.vue'
import { getUserRole } from '@/services/AuthService'

export default {
  components: {
    DashboardStatisticsCard,
    DashboardCardSalesByTrips,
    DashboardWeeklyOverview,
    CompanyNetProfitModal,
    BookingRevenueModal,
    DriverEarningsModal,
    RefundsModal,
  },
  data() {
    return {
      isLoading: false,
      showCompanyNetProfitModal: false,
      showBookingRevenueModal: false,
      showDriverEarningsModal: false,
      showRefundsModal: false,
      totalReservations: {
        statTitle: 'Total Reservations',
        amount: '',
      },
      bestTrips: [],
      plannedTripsCount: [],
      plannedTripsDates: [],
      bestTripsColors: [
        '#8B5CF6', '#3B82F6', '#10B981', '#F59E0B', '#EF4444',
      ],
      totalDriversEarnings: {
        statTitle: 'Drivers Earnings',
        amount: '',
      },
      totalRefunds: {
        statTitle: 'Total Refunds',
        amount: '',
      },
      totalAdminEarnings: null,
      allCounts: [
        { title: 'Reservations', total: '' },
        { title: 'Customers', total: '' },
        { title: 'Drivers', total: '' },
        { title: 'Routes', total: '' },
        { title: 'Stops', total: '' },
        { title: 'Trips', total: '' },
      ],
    }
  },
  created() {
    const role = getUserRole();
    if (role === 5) {
      this.$router.replace('/customer-service');
      return;
    } else if (role === 4) {
      this.$router.replace('/operations');
      return;
    } else if (role === 3) {
      this.$router.replace('/routes');
      return;
    }
  },
  mounted() {
    const role = getUserRole();
    if (role !== 0) return;
    this.fetchDashboardStatistics()
  },
  methods: {
    fetchDashboardStatistics() {
      this.isLoading = true;
      axios
        .get(`/dashboard/all`)
        .then((response) => {
          if (response && response.data) {
            this.totalReservations.amount = response.data.totalReservations || '0';
            this.totalDriversEarnings.amount = response.data.totalDriversEarnings || '0.00 EGP';
            this.totalRefunds.amount = response.data.totalRefunds || '0.00 EGP';
            this.totalAdminEarnings = response.data.totalAdminEarnings || null;
            
            this.allCounts[0].total = response.data.totalReservationsCount || 0;
            this.allCounts[1].total = response.data.totalCustomers || 0;
            this.allCounts[2].total = response.data.totalDrivers || 0;
            this.allCounts[3].total = response.data.totalRoutes || 0;
            this.allCounts[4].total = response.data.totalStops || 0;
            this.allCounts[5].total = response.data.totalTrips || 0;
            
            const bestTrips = Array.isArray(response.data.bestTrips) ? response.data.bestTrips : [];
            bestTrips.forEach((item, index) => {
              item.color = this.bestTripsColors[index % this.bestTripsColors.length];
            });
            this.bestTrips = bestTrips;
            
            this.plannedTripsCount = [];
            this.plannedTripsDates = [];
            if (response.data.plannedTrips) {
              for (var key in response.data.plannedTrips) {
                this.plannedTripsCount.push(response.data.plannedTrips[key]);
                this.plannedTripsDates.push(key);
              }
            }
          }
        })
        .catch((error) => {
          this.$notify({
            title: "Error",
            text: "Error while retrieving dashboard statistics",
            type: "error",
          });
          console.error(error);
          if (error && error.response && error.response.data && error.response.data.message) {
            auth.checkError(error.response.data.message, this.$router, this.$swal);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
}
</script>

<style lang="scss" scoped>
.summary-card {
  background-color: #FFFFFF !important;
  border-radius: 12px !important;
  border: 1px solid #E4E8F0 !important;
  height: 140px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.02) !important;
  transition: all 0.25s ease;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06) !important;
  }
}

.clickable-card, .cursor-pointer {
  cursor: pointer;
}

.gradient-card {
  background: linear-gradient(135deg, #082C69 0%, #1A4790 100%) !important;
  border: none !important;
}

.dashboard-chart-card {
  background-color: #FFFFFF !important;
  border-radius: 12px !important;
  border: 1px solid #E4E8F0 !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.02) !important;
}

.white-opacity-bg {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.opacity-80 {
  opacity: 0.8;
}

.opacity-90 {
  opacity: 0.9;
}

.tracking-wider {
  letter-spacing: normal;
}

.gold--text {
  color: #F5A114 !important;
}

.grey-text {
  color: #64748B !important;
}

.dark-blue-text {
  color: #061B40 !important;
}

.border-1 {
  border: 1px solid #E4E8F0 !important;
}
</style>
